import { z } from 'zod';

// Master connection state (per workspace). Mirrors the existing MasterState
// shape used by the master-status route.
export const MasterConnectionStateSchema = z.enum(['not_configured', 'offline', 'online']);

// PUT body — token optional (absent/blank = keep existing).
export const MasterConnectionConfigSchema = z.object({
  ws_url: z.string().min(1),
  enabled: z.boolean(),
  token: z.string().min(1).optional(),
});

// GET response — never carries the token.
export const MasterConnectionViewSchema = z.object({
  ws_url: z.string(),
  enabled: z.boolean(),
  token_set: z.boolean(),
});

export type ParsedMasterConnectionState = z.infer<typeof MasterConnectionStateSchema>;
export type ParsedMasterConnectionConfig = z.infer<typeof MasterConnectionConfigSchema>;
export type ParsedMasterConnectionView = z.infer<typeof MasterConnectionViewSchema>;
